function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-category-highlight\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.59,18.78H24.21a3,3,0,0,1-3-3V7.4a3,3,0,0,1,3-3h8.38a3,3,0,0,1,3,3v8.38A3,3,0,0,1,32.59,18.78ZM24.21,6.65a.76.76,0,0,0-.75.75v8.38a.76.76,0,0,0,.75.75h8.38a.76.76,0,0,0,.75-.75V7.4a.76.76,0,0,0-.75-.75Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.79,18.78H7.41a3,3,0,0,1-3-3V7.4a3,3,0,0,1,3-3h8.38a3,3,0,0,1,3,3v8.38A3,3,0,0,1,15.79,18.78ZM7.41,6.65a.76.76,0,0,0-.75.75v8.38a.76.76,0,0,0,.75.75h8.38a.76.76,0,0,0,.75-.75V7.4a.76.76,0,0,0-.75-.75Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.59,35.6H24.21a3,3,0,0,1-3-3V24.22a3,3,0,0,1,3-3h8.38a3,3,0,0,1,3,3V32.6A3,3,0,0,1,32.59,35.6ZM24.21,23.47a.75.75,0,0,0-.75.75V32.6a.76.76,0,0,0,.75.75h8.38a.76.76,0,0,0,.75-.75V24.22a.75.75,0,0,0-.75-.75Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.79,35.6H7.41a3,3,0,0,1-3-3V24.22a3,3,0,0,1,3-3h8.38a3,3,0,0,1,3,3V32.6A3,3,0,0,1,15.79,35.6ZM7.41,23.47a.75.75,0,0,0-.75.75V32.6a.76.76,0,0,0,.75.75h8.38a.76.76,0,0,0,.75-.75V24.22a.75.75,0,0,0-.75-.75Z",
  fill: "#231f20"
});

function SvgCmsCategoryHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgCmsCategoryHighlight;